import { render, staticRenderFns } from "./Sicbo.vue?vue&type=template&id=33661f88&scoped=true"
import script from "./Sicbo.vue?vue&type=script&lang=js"
export * from "./Sicbo.vue?vue&type=script&lang=js"
import style0 from "./Sicbo.vue?vue&type=style&index=0&id=33661f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33661f88",
  null
  
)

export default component.exports